<dib-header></dib-header>
<dib-sidenav>
  <ng-content></ng-content>
</dib-sidenav>
